import React from 'react';
import type { SVGDefaultProps } from './types';
import { colors } from '@/styles';
import { isColorName } from '@/styles/colorUtils';

export const Close = ({
  size = 16,
  title = 'Close',
  fill = colors.silverSandAlt,
}: SVGDefaultProps) => {
  const height = Number(size) * 2.85;

  let svgFill = fill;
  if (isColorName(fill)) {
    console.warn('Using deprecated fill prop for Close svg, fill should be a hex.');
    svgFill = colors[fill];
  }

  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 0 25.01 25">
      {Boolean(title) && <title>{title}</title>}
      <path
        d={`
          M.55,24.48a1.7,1.7,0,0,0,2.45,0L12.53,15l9.52,9.52a1.74,1.74,0,0,0,1.23.52,
          1.73,1.73,0,0,0,1.23-.52,1.78,1.78,0,0,0,0-2.48L15,12.51,24.51,3a1.78,1.78,
          0,0,0,0-2.48A1.75,1.75,0,0,0,22,.51h0L12.52,10,3,.54A1.76,1.76,0,0,0,.51,
          3h0L10,12.51.54,22a1.69,1.69,0,0,0-.05,2.39h0A.19.19,0,0,0,.55,24.48Z
        `}
        fill={svgFill}
      />
    </svg>
  );
};
